export const getSlugs = (pathname: string) => pathname.replace('/', '').split('#')[0].split('/');
